export default "__VITE_ASSET__497600c5__"